import { useQuery } from "@tanstack/react-query";
import { getTaskCommentsImages } from "@coworker/apprestructured/src/task-management/services/tasks.service";
import { getTaskCommentsImagesQueryKey } from "@coworker/apprestructured/src/task-management/services/queryKeyHelper";
import { createPreviousOnNullPlaceholderDataFn } from "@coworker/apprestructured/src/task-management/services/queryHelper";
import { SignedUpload } from "@coworker/apprestructured/src/task-management/types/Upload";

export function useTaskCommentsImages(taskId: string | null) {
  return useQuery({
    queryKey: getTaskCommentsImagesQueryKey(taskId),
    queryFn: () => getTaskCommentsImages(taskId!),
    enabled: taskId !== null,
    placeholderData:
      createPreviousOnNullPlaceholderDataFn<SignedUpload[]>(taskId),
  });
}
